import defnePic from "@/public/images/artists/defne.png";
import { Artist } from "@/types/types";

export const defne = {
  id: "294",
  name: "Defne",
  image: defnePic,
  description: `Defne has a bold voice with a rich tone, a sharp edge, and a confident, high-impact delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdefne-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Dance", "Soul", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "High",
      },
      specific: {
        low: 55,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
